module.exports = __webpack_public_path__ + "img/dank-mono-dark.dbb6f3da.png";